module.exports = "<div class=table-category> {{ category }} </div> <div class=\"table-category sub-category\" *ngIf=subCategory> {{subCategory}} </div> ";